export default {
  getList: {
    method: 'post',
    url: '/vehicle/repair/list'
  },
  getById: {
    method: 'get',
    url: '/vehicle/repair/ID'
  },
  add: {
    method: 'post',
    url: '/vehicle/repair'
  },
  delete: {
    method: 'delete',
    url: '/vehicle/repair'
  },
  archive: {
    method: 'delete',
    url: '/vehicle/repair/archive'
  },
  edit: {
    method: 'put',
    url: '/vehicle/repair/ID'
  }
}
